import { FileText, Receipt, Target } from "lucide-react";

import { useEncounterId } from "@src/features/encounters";
import { SectionHeader } from "@src/shared/components/general/SectionHeader";
import {
  Flexbox,
  HorizontalFlexbox,
  VerticalFlexbox,
} from "@src/shared/components/layout/Flexbox";

import { CodingCard } from "./CodingCard";
import { useMedicalCodes } from "./useMedicalCodes";

export const Coding = () => {
  const encounterId = useEncounterId();
  const { data, isLoading, isError } = useMedicalCodes(
    encounterId ?? undefined,
  );

  const icd10 = data?.data.icd10;
  const cpt = data?.data.cpt;
  const vbc = data?.data.vbc;
  const codingStatus = data?.data.codingStatus;

  return (
    <VerticalFlexbox gap="sm">
      <HorizontalFlexbox
        alignItems="center"
        justifyContent="space-between"
        gap="xs"
      >
        <SectionHeader>CODING</SectionHeader>
      </HorizontalFlexbox>
      <Flexbox
        gap="sm"
        className="flex-col md-stitch:flex-row md-stitch:flex-wrap"
      >
        <CodingCard
          icon={FileText}
          title="Diagnosis Codes (ICD-10)"
          rows={icd10 ?? []}
          isLoading={isLoading}
          isError={isError}
          codingStatus={codingStatus}
        />
        <CodingCard
          icon={Receipt}
          title="Procedure Codes (CPT)"
          rows={cpt ?? []}
          isLoading={isLoading}
          isError={isError}
          codingStatus={codingStatus}
        />
        <CodingCard
          icon={Target}
          title="VBC"
          rows={vbc ?? []}
          isLoading={isLoading}
          isError={isError}
          codingStatus={codingStatus}
        />
      </Flexbox>
    </VerticalFlexbox>
  );
};
